<template>
    <div class="sustainability-env">
      <div class="sustainability-env-content">
          <p class="indent">Опазването на околната среда и ефективното използване на природните ресурси са сред основните приоритети в развитието на компанията. Производствената дейност се осъществява в съответствие с европейските директиви, имплементирани и в българското законодателство.</p>
        <p class="indent">През последните години инвестициите в модернизиране и разширяване на производствените мощности неизменно са съпътствани и от внедряване на съвременни пречиствателни съоръжения. В компанията са разработени и програми за управление на генерираните в резултат на производствената дейност отпадъци, като основната част от тях се предава за оползотворяване в други сектори на промишлеността.</p>
          <img v-scroll-reveal.reset class="row-img" src="/static/img/sustainability/environment/env.jpg" alt="">
          <p class="indent">В изпълнение политиката по опазване на околната среда е разработена и внедрена Интегрирана система за управление, покриваща изискванията на стандарт EN ISO 14001.</p>
          <p class="indent">В процеса на технологично обновяване и модернизация на производството водещи приоритети са опазването на околната среда при ефективно използване на природни ресурси.</p>
          <p class="indent">Въведените технически и технологични решения, отчитащи най–добрите налични техники,  гарантират високо ниво на пречистване на използвания воден ресурс и на отделяните емисии в атмосферата.</p>
          <p class="indent">Ръководството на компанията осъзнава своята  отговорност по отношение опазване на климата. Всички текущи и бъдещи инвестиции са насочени към  енергийно ефективни технологии и съоръжения.  При значителното увеличение на производствения (горивен) капацитет на инсталацията през последните години е постигнато относително намаляване на отделените специфични емисии парникови газове (СО2 емисии).</p>
        <p class="indent">Компанията е извършила Оценка на жизнения цикъл (LCA), която е налична и може да бъде предоставена на всички заинтересовани страни при поискване.</p>
        <p class="indent">LCA изследването прилага допускания относно заместващи емисионни фактори, транспортни маршрути на веригата за доставки, моделиране на химически продукти. Системните граници на LCA са резултат от процесите, които не са под пряк контрол на производителя, включително производството на енергия, производството на ресурси (като първичен и вторичен алуминий).</p>

          <p class="indent">Наличието на топилни агрегати осигурява възможността генерирания на територията на България алуминиев скрап да бъде рециклиран и повторно вложен в производствения процес. Акт, в резултат на който се  спестяват високите енергийни разходи и ограничават  вредните емисии при производството на първичен алуминий.</p>
          <p class="indent">В компанията са разработени програми за управление на генерираните в резултат на производствената дейност отпадъци. Основна част от тези отпадъци се оползотворяват като суровини в други сектори на промишлеността.</p>
        <p class="indent">С активната си политика и предприети мерки в областта на опазване на околната среда Алкомет изразява визията си за успешен бизнес, в интерес на обществото.
          </p>
          <!-- <div class="row">
            <div class="row-text">
              <p class="indent">The existing melting furnaces enable the recycling and reuse of aluminium scrap generated in Bulgaria, thus reducing high energy costs and limiting the harmful emissions resulting from the production of primary aluminium.</p>
              <p class="indent">Consistent with its environmental policy, the company has developed and introduced an Integrated Management System in compliance with the requirements of EN ISO 14001.</p>
            </div>
            <div class="row-img" :style="{ backgroundImage : `url(${'/static/img/sustainability/environment/env.jpg'})` }"></div>
          </div> -->
          <p>
            <a href="/static/files/Alcomet-Environmental-Management-Policy.pdf" target="_blank">Политика по околна среда</a>
          </p>
      </div>
      <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.sustainability-env-content {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sustainability-env-content > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.row {
  display: flex;
  margin: 30px auto;
  width: 80%;
}
.row-text {
  margin-right: 20px;
  width: 33.33%;
}
.row-img {
  border-radius: 6px;
  margin: 20px auto;
  min-height: 1px;
  width: 60%;
}
a {
  text-decoration: underline;
}
@media screen and (max-width: 1000px) {
  .sustainability-env {
    padding-bottom: 20px;
  }
  .sustainability-env-content > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .row-img {
    width: calc(100% - 60px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sustainability/Environment.vue